<template>
  <div>
    <div class="navbar-minimize-fixed">
      <button class="minimize-sidebar btn btn-link btn-just-icon">
        <i class="tim-icons icon-align-center visible-on-sidebar-regular text-muted"></i>
        <i class="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted"></i>
      </button>
    </div>
    <Sidebar id="step-one"></Sidebar>
    <div class="main-panel">
      <div v-if="this.$store.state.marketStatus == 'close' && isOpen" class="close-market">
        <h4 class="close-market-font rounded">The market is currently closed <span class="close-market-exit"
            @click="exitCloseMarket()">x</span></h4>
      </div>
      <Navbar ref="navbarCall"></Navbar>

      <router-view></router-view>

      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import Navbar from '@/components/layout/Navbar.vue'
import Sidebar from '@/components/layout/Sidebar.vue'
import Footer from '@/components/layout/Footer.vue'
import Swal from 'sweetalert2'
// import PerfectScrollbar from 'perfect-scrollbar'
import introJs from 'intro.js'

export default {
  name: 'Dash',
  components: {
    Navbar,
    Sidebar,
    Footer
  },
  data() {
    return {
      webName: process.env.VUE_APP_TITLE,
      pageName: this.$route.name,
      isOpen: true,

      swalActivated: false,

      userActivityThrottlerTimeout: null,

      apiStatusRefreshToken: 'idle'
    }
  },
  created() {
    // change theme color CSS
    const r = document.querySelector(':root')
    if (this.$store.state.appName == 'PosPayGold') { // pospaygold
      r.style.setProperty('--theme-color', getComputedStyle(r).getPropertyValue('--orange-pospaygold'))
    } else if (this.$store.state.appName == 'NUNomics') { // nunomics
      r.style.setProperty('--theme-color', getComputedStyle(r).getPropertyValue('--hijau-nu'))
    } else if (this.$store.state.appName == 'BMTDigi') { // bmtdigi
      r.style.setProperty('--theme-color', getComputedStyle(r).getPropertyValue('--orange-bmt'))
    } else if (this.$store.state.appName == 'AGIGold') { // AGIGold
      r.style.setProperty('--theme-color', getComputedStyle(r).getPropertyValue('--biru-agi'))
    }
    
    // for(let key in this.$store.state.customContractIds) {
    //   console.log('WERWERWER', this.$store.state.customContractIds.contractId_100g, key)
    // }

    const loginExpiredTime = Number(localStorage.getItem('loginExpiredTime'))
    if (loginExpiredTime) {
      if (Date.now() > loginExpiredTime) { this.$store.dispatch('AUTH_LOGOUT').then(() => { this.$router.push({ name: 'Login' }) }) }
    }

    this.activateActivityTracker()


    if (this.$store.state.token) {
      this.setStreamingRate()

      this.$store.dispatch('setContracts')
      this.$store.dispatch('setProducts')
      // this.$store.dispatch('setAccountInformation')
      this.$store.dispatch('setBalances')
      // this.$store.dispatch('setGoldBalances')

      this.everyThreeSeconds()
      this.setStreamingRate()

      // this.$store.dispatch('setContracts')
      //   .then(() => {

      //     if (this.$store.state.token) {
      //       this.callFunction()

      //       this.$store.dispatch('setDepths')
      //         .then(() => {
      //           this.$store.dispatch('setCustomDepth')
      //           this.$store.dispatch('setGold')
      //         })
      //     }

      //   })
    }
  },

  async mounted() {

    await new Promise((resolve) => {
      let intro1 = introJs()

      intro1.setOptions({
        steps: [
          {
            element: document.querySelector('#step-one'),
            intro: 'Menu bar'
          },
        ],

        dontShowAgain: true
      })

      intro1.onbeforeexit(() => {
        resolve()
      })

      intro1.start()

    })

    this.$refs.navbarCall.callIntroNavbar()

  },

  beforeDestroy() {
    window.removeEventListener("mousemove", this.userActivityThrottler)
    window.removeEventListener("scroll", this.userActivityThrottler)
    window.removeEventListener("keydown", this.userActivityThrottler)
    window.removeEventListener("resize", this.userActivityThrottler)

    clearTimeout(this.userActivityThrottlerTimeout)
  },
  methods: {
    everyThreeSeconds() {
      const token = window.localStorage.getItem('token')
      if (!token) return

      setTimeout(async () => {
        try {
          await this.$store.dispatch('setDepths')
          await this.$store.dispatch('setGolds')
          // await this.$store.dispatch('setOhlc')

          this.everyThreeSeconds()
        } catch (err) {
          this.everyThreeSeconds()
        }

        // this.everyThreeSeconds()
      }, 3000)
    },

    async setStreamingRate() {
      const token = window.localStorage.getItem('token')
      if (!token) return

      let nextGetStreamingRate = this.$store.state.nextGetStreamingRate
      if (!nextGetStreamingRate || !this.$store.state.streamingRate) {
        await this.$store.dispatch('setStreamingRate')
        nextGetStreamingRate = this.$store.state.nextGetStreamingRate
      }

      // if nextGetStreamingRate is less than current time, wait for 5 second, then get streaming rate again
      if (nextGetStreamingRate <= new Date().getTime()) {
        setTimeout(() => {
          this.$store.dispatch('setStreamingRate'
          ).then(() => {
            this.setStreamingRate()
          })
        }, 5000)

        return
      }

      setTimeout(() => {
        this.$store.dispatch('setStreamingRate')
          .then(() => {
            this.setStreamingRate()
          })
      }, Math.max(nextGetStreamingRate - new Date().getTime(), 0))
    },

    callFunction() {
      // this.$store.dispatch('setProducts')
      this.$store.dispatch('setHoldings')
      // this.$store.dispatch('setContracts')
    },

    // async setStreamingRate() {
    //   const token = window.localStorage.getItem('token')
    //   if (!token) return

    //   let nextGetStreamingRate = this.$store.state.nextGetStreamingRate
    //   if (!nextGetStreamingRate) {
    //     await this.$store.dispatch('setStreamingRate')
    //     nextGetStreamingRate = this.$store.state.nextGetStreamingRate
    //   }

    //   // if nextGetStreamingRate is less than current time, wait for 5 second, then get streaming rate again
    //   if (nextGetStreamingRate <= new Date().getTime()) {
    //     setTimeout(() => {
    //       this.$store.dispatch('setStreamingRate'
    //       ).then(() => {
    //         this.setStreamingRate()
    //       })
    //     }, 5000)

    //     return
    //   }

    //   setTimeout(() => {
    //     this.$store.dispatch('setStreamingRate')
    //       .then(() => {
    //         this.setStreamingRate()
    //       })
    //   }, Math.max(nextGetStreamingRate - new Date().getTime(), 0))
    // },

    exitCloseMarket() {
      this.isOpen = false
    },

    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler)
      window.addEventListener("scroll", this.userActivityThrottler)
      window.addEventListener("keydown", this.userActivityThrottler)
      window.addEventListener("resize", this.userActivityThrottler)

    },
    resetUserActivityTimeout() {
      localStorage.setItem('loginExpiredTime', Date.now() + this.$store.state.loginExpiredTimeState)
    },
    userActivityThrottler() {
      if (!this.userActivityThrottlerTimeout) {
        this.userActivityThrottlerTimeout = setTimeout(() => {
          const loginExpiredTime = Number(localStorage.getItem('loginExpiredTime'))
          if (Date.now() < loginExpiredTime) {
            this.resetUserActivityTimeout()
          } else if (!this.swalActivated && Date.now() >= loginExpiredTime) {
            this.swalActivated = true
            this.$store.dispatch('AUTH_LOGOUT').then(() => {
              Swal.fire({
                background: '#191f31',
                title: '<span style="color: white;">Your session has expired</span>',
              }).then(() => {
                clearTimeout(this.userActivityThrottlerTimeout)
                this.userActivityThrottlerTimeout = null

                this.swalActivated = false

                this.$router.push({ name: 'Login' })
              })
            })
          }

          clearTimeout(this.userActivityThrottlerTimeout)
          this.userActivityThrottlerTimeout = null
        }, 3000)
      }
    },
  }
}
</script>

<style scoped>
#container {
  background: green;
}

.close-market {
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 20%;
  width: 100%;
  background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1));
  text-align: center;
}

.close-market-font::before {
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
  content: "\f024";
  margin-right: 15px;
}

.close-market-font {
  position: relative;
  vertical-align: middle;
  color: #222;
  background-color: #777;
  display: inline-block;
  margin-top: 30px;
  padding: 10px 20px;
}

.close-market-exit {
  color: #f05a28 !important;
  cursor: pointer;
  position: absolute;
  top: -5px;
  right: -7px;
  background-color: #1a1e34;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  margin: 0px;
  display: inline-block;
  font-weight: bold;
  line-height: 1em;
  transition: color .1s ease-in-out;
  border: 1px #777 solid;
}
</style>
